<template>
  <div class="card" @click="$emit('card-selected')">
    <md-card :style="{ backgroundColor: backgroundColor, color: [(backgroundColor === 'yellow') || (backgroundColor === 'orange') ? 'black' : 'white'] }" >
      <md-card-header>
        <md-card-header-text>
          <div class="md-title"><h3>{{cardName}}</h3></div>
          <div class="md-subhead">{{cardSubtitle}}</div>
        </md-card-header-text>
        <md-card-media class="cancel-button">
          <md-button
              class="md-icon-button md-dense"
              v-show="showDiscardOption"
              @click.stop="$emit('discard-card')">
            <md-icon :style="{color: [(backgroundColor === 'yellow') || (backgroundColor === 'orange') ? 'black' : 'white']}">cancel</md-icon>
          </md-button>

        </md-card-media>
      </md-card-header>

      <md-card-actions :style="{ backgroundColor: backgroundColor, color: [(backgroundColor === 'yellow') || (backgroundColor === 'orange') ? 'black' : 'white'] }">
        <md-button
                class="blockButton"
                v-show="showCardAction"
                @click="$emit('card-action')"
                :style="{ backgroundColor: backgroundColor, color: [(backgroundColor === 'yellow') || (backgroundColor === 'orange') ? 'black' : 'white'] }"
        >
          Card Action</md-button>

        <md-button
            class="blockButton"
            v-show="showPassingOption"
            @click="$emit('pass-to-player')"
            :style="{ backgroundColor: backgroundColor, color: [(backgroundColor === 'yellow') || (backgroundColor === 'orange') ? 'black' : 'white'] }"
        >
          Pass Card</md-button>
      </md-card-actions>

    </md-card>
  </div>
</template>

<script>
  export default {
    name: "Card",
    props: {
      cardName: String,
      cardSubtitle: String,
      backgroundColor: String,
      showPassingOption: Boolean,
      showDiscardOption: Boolean,
      showCardAction: Boolean
    }
  }
</script>

<style scoped>
  .card {
    cursor: pointer;
  }
  .blockButton {
    display: block;
  }
  .md-card .md-title {
    font-size: 1.2em;
    padding: 0;
  }
  .card {
    margin-top: 8px;
  }
  .cancel-button {
    position: absolute;
    top: -8px;
    right:-32px;
  }
  .md-title{
    text-align: center;
  }
  .md-title h3{
    padding: 0 !important;
    margin: 0 !important;
  }
</style>